import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MarkdownModule } from 'ngx-markdown';
import { LoginRouting } from './login.routing';
import { LoginComponent } from './login.component';
import { SharedModule } from '../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser'; 
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    LoginRouting,
    FormsModule,
    ReactiveFormsModule,
    MarkdownModule.forChild(),
    MatCheckboxModule,
    SharedModule,
    BrowserModule,
    HttpClientModule
  ],
  declarations: [
    LoginComponent    
  ]
})
export class LoginModule { }
